import { useEffect, useState } from "react";
import { useEditorMaybe } from "@grapesjs/react";
import Select from "react-select";
import { editorStyleSelectSelectorForCurrentDevice } from "../../helpers/parentChildSelectorHelpers.js";

const ChooseSelector = () => {
  const editor = useEditorMaybe();

  const DEFAULT = "Select";
  const [selectedSelector, setSelectedSelector] = useState(DEFAULT);
  const [selectors, setSelectors] = useState([]);

  function handleFetchSelectors(arg, oldDevice) {
    // oldDevice && oldDevice.attributes && oldDevice?.attributes.hasOwnProperty("widthMedia") ? console.log("on device change -", oldDevice) : console.log("component-selected");
    const selectedComponent = editor.getSelected();
    // if(!selectedComponent || selectedComponent.is("wrapper")) {
    if (!selectedComponent) {
      setSelectors([]);
      setSelectedSelector(DEFAULT);
      return;
    }

    const getSelectorComponents = (selector) => editor.getWrapper().find(selector);

    const currentDevice = editor.DeviceManager.getSelected();
    const isCurrentDeviceDefault = currentDevice.id === "Default";

    const selectedComponentHTML = selectedComponent.toHTML({ withProps: true });
    const matchingRules = editor.CssComposer.getRules().filter((rule) => {
      try {
        const ruleSelectorString = rule.selectorsToString();
        if (["*", ""].includes(ruleSelectorString.trim())) return false; // ignore if rule contains "*" or ""

        if (rule.getAtRule().startsWith("@keyframes")) return false; // ignore @keyframes css

        if (Object.keys(rule.get("style")).length === 0) return false; // ignore if no styles exist for the rule

        // get css rules only of the current media query
        if (isCurrentDeviceDefault) {
          // if default device, ignore if "@" exists in css rule
          if (rule.get("atRuleType") !== "") return false;
        } else {
          // for other devices, ignore if device width is not matching
          if (rule.get("atRuleType") !== "media" || !rule.get("mediaText").includes(currentDevice.attributes.width)) return false;
        }

        const thisRuleElements = getSelectorComponents(rule.selectorsToString());
        if (thisRuleElements.length === 0) return false; // ignore if there are no matching elements for the rule

        // compare css rule elements with selected element and see if at least one matches
        return thisRuleElements.some((ruleElement) => selectedComponentHTML === ruleElement.toHTML({ withProps: true }));
      } catch (err) {
        console.log(err);
        return false;
      }
    });

    setSelectors([DEFAULT, ...matchingRules.map((rule) => rule.selectorsToString())]);
    setSelectedSelector(DEFAULT);
  }

  const handleSelectSelector = (selected) => {
    if (selected.value === DEFAULT) {
      const selectedComponent = editor.getSelected();
      editor.selectRemove(selectedComponent);
      editor.select(selectedComponent);
    }

    setSelectedSelector(selected.value);
  };

  useEffect(() => {
    if (editor) {
      if (selectedSelector !== DEFAULT) {
        // editor.StyleManager.select(selectedSelector);
        editorStyleSelectSelectorForCurrentDevice(editor, selectedSelector);
        document.querySelector("#selector-container span.gjs-clm-sel").innerHTML = `<span class="gjs-clm-sel-rule">${selectedSelector}</span>`;
      }
    }
  }, [selectedSelector]);

  useEffect(() => {
    if (editor) {
      editor.on("component:selected", handleFetchSelectors);
      editor.on("device:select", handleFetchSelectors);

      return () => {
        editor.off("component:selected", handleFetchSelectors);
        editor.off("device:select", handleFetchSelectors);
      };
    }
    // }, [editor?.getSelected(), editor?.getDevice()]);
  });

  if (!editor) return <></>;

  return (
    <>
      <div className="choose-selector mb-2">
        <label className="small fw-semibold">Choose Existing Selector:</label>
        {/* <Button
          size="sm"
          variant="primary"
          className="p-1"
          onClick={handleFetchSelectors}
        >
          <small>Reset Options</small>
        </Button> */}
        <Select
          options={selectors.map((selector) => ({ value: selector, label: selector }))}
          value={{ value: selectedSelector, label: selectedSelector }}
          onChange={handleSelectSelector}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: selectedSelector === DEFAULT ? "transparent" : "#ed0677",
              fontSize: "13px",
            }),
            singleValue: (baseStyles) => ({
              ...baseStyles,
              color: selectedSelector === DEFAULT ? "black" : "white",
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              color: selectedSelector === DEFAULT ? "black" : "white",
            }),
            option: (baseStyles) => ({
              ...baseStyles,
              fontSize: "13px",
              display: "block",
            }),
            menuList: (baseStyles) => ({
              ...baseStyles,
              maxHeight: "200px",
              overflowY: "auto",
            }),
          }}
        />
      </div>
    </>
  );
};

export default ChooseSelector;
